export const PROJECT_CONSTANTS = {
  DEFAULT_OPTIMIZATION_FOR_PV: 100,
  DEFAULT_BUILDING_CURRENT_STATUS: "unsaniert",
  DEFAULT_HWB_FROM_EA_AS_PLANNED: 0,
  DEFAULT_ROOF_AREA: 0,
  DEFAULT_USEABLE_ROOF_AREA: 0,
  DEFAULT_ORIENTATION: "S",
  DEFAULT_INCLINATION_OF_ROOF: "0 Grad",
}
